import * as Sentry from '@sentry/react';

/**
 * Wraps a function in a performance span. If Sentry is not available, just runs the callback.
 * @param {object} options - Span options (name, op, attributes, etc)
 * @param {function} fn - The function to execute within the span
 * @returns {Promise|any} The result of the function
 */
export function withSpan(options, fn) {
  if (typeof Sentry.startSpan === 'function') {
    return Sentry.startSpan(options, fn);
  }
  // Fallback: just run the function
  return fn();
}
